/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddNoteInput } from '../models/AddNoteInput';
import type { NoteDto } from '../models/NoteDto';
import type { UpdateNoteInput } from '../models/UpdateNoteInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NoteService {

    /**
     * @param version 
     * @param requestBody 
     * @returns NoteDto OK
     * @throws ApiError
     */
    public static addNote(
version: string,
requestBody?: AddNoteInput,
): CancelablePromise<NoteDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Note',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param noteId 
     * @param version 
     * @param requestBody 
     * @returns NoteDto OK
     * @throws ApiError
     */
    public static updateNote(
noteId: number,
version: string,
requestBody?: UpdateNoteInput,
): CancelablePromise<NoteDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/v{version}/Note/{noteId}',
            path: {
                'noteId': noteId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param noteId 
     * @param version 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteNote(
noteId: number,
version: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/v{version}/Note/{noteId}',
            path: {
                'noteId': noteId,
                'version': version,
            },
        });
    }

}
